import React from 'react';

export interface LegendUIContextValue {
  isLegendCollapsed: boolean;
  setIsLegendCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
  onOpenDetailsLegendInSidebar?: () => void;
}

export const LegendUIContext = React.createContext<LegendUIContextValue>({
  isLegendCollapsed: false,
  setIsLegendCollapsed: () => {},
});
